import { render, staticRenderFns } from "./task-video-call.vue?vue&type=template&id=52ba7196&scoped=true&"
import script from "./task-video-call.vue?vue&type=script&lang=js&"
export * from "./task-video-call.vue?vue&type=script&lang=js&"
import style0 from "./task-video-call.vue?vue&type=style&index=0&id=52ba7196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba7196",
  null
  
)

export default component.exports